import API from "../API";
import Authentication from "./Authentication";

var User = {
    async search(data) {
        var result = await API.process(
            'api/Users/search',
            'POST',
            data
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async SearchMessageRecipientUser(data) {
        var result = await API.process(
            'api/Users/search/message/send',
            'POST',
            data
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async get(id) {
        var result = await API.process(
            'api/Users/' + id,
            'GET',
            null
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async LookupByIDNumber(idNumber) {
        var result = await API.process(
            `api/Users/LookupByIDNumber/${idNumber}`,
            'GET',
            null
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async GetUsersByFacility(facilityId) {
        var result = await API.process(
            `api/Users/byFacility/${facilityId ? facilityId : "-1"}`,
            'GET',
            null
        ).catch((err) => {
            throw err;
        })
        return result
    },
    async add(user) {
        var result = await API.process(
            'api/Users/',
            'POST',
            user
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async edit(userId, user) {
        var result = await API.process(
            'api/Users/' + userId,
            'PUT',
            user
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async permissions(userId) {
        var result = await API.process(
            'api/Users/permissions',
            'GET',
            null
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async addPermissions(userId, priv) {
        var result = await API.process(
            'api/Users/permissions/' + userId,
            'PATCH',
            priv
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async removePermissions(userId, priv) {
        var result = await API.process(
            'api/Users/permissions/' + userId + "/" + priv.Id,
            'DELETE',
            priv
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async facilities(userId) {
        var result = await API.process(
            'api/Users/facilities',
            'GET',
            null
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async addFacility(userId, facilityId, roleId) {
        await API.process(
            'api/Users/facility/' + userId + '/' + facilityId + '/' + roleId,
            'PUT',
            null
        ).catch((err) => {
            throw err;
        })
    },
    async GetAccessableUsers() {
        var result = await API.process(
            'api/Users/Accessibility',
            'GET',
            null
        ).catch((err) => {
            throw err;
        })
        return result
    },
    async GetAccessableUsersByType(type) {
        var result = await API.process(
            'api/Users/Accessibility/' + type,
            'GET',
            null
        ).catch((err) => {
            throw err;
        })
        return result
    },
    async GetAccessableFacilityUsers(facilityId, type) {
        var result = await API.process(
            `api/Users/Accessibility/facility/${facilityId}/${type}`,
            'GET',
            null
        ).catch((err) => {
            throw err;
        })
        return result
    },
    async GetUserStatus(userId) {
        var result = await API.process(
            `api/Users/wizard/status/${userId}`,
            'GET',
            null
        ).catch((err) => {
            throw err;
        })
        return result
    },
    async UserRevokeFacility(facility) {
        var result = await API.process(
            `api/Users/revoke/${facility}`,
            'PUT',
            null
        ).catch((err) => {
            throw err;
        })
        return result
    },
    async ListUserTypes() {
        var result = await API.process(
            `api/Users/types`,
            'GET',
            null
        ).catch((err) => {
            throw err;
        })
        return result
    },
    async ListFacilitiesUsers(type) {
        var result = await API.process(
            `api/Users/facilities/${Authentication.getFacility()}/users?type=${type}`,
            'GET',
            null
        ).catch((err) => {
            throw err;
        })
        return result
    }
}

export default User;